import userInfoTypes from '../types/userActionTypes';
import paymentTypes from '../types/paymentType';
import { keysToLowerCase } from "../../Utilities/helpers";
import driverActionTypes from "../types/driverActionTypes";
import tagActionTypes from "../types/tagActionTypes";
import invoiceActionTypes from "../types/invoiceActionTypes";

const initialState = {
    stateInfo: {
        isLoading: false,
        isSuccess: false,
        isError: false,
        error: null,
        actionType: null
    },
    userInfo: {
        token: null,
        isOPU: false,
        isInitialLogin: true,
    },
    paymentInfo: null,
    driversInfo: [],
    isLoggedIn: false,
}


const userInfoReducer = (state = initialState, action) => {
    switch (action.type) {
        // user actions
        case userInfoTypes.LOGIN_SUCCESS:
        case userInfoTypes.REGISTE_SUCCESS:
            return setLoginSuccess(state, action);
        case userInfoTypes.GET_USER_DETAILS_SUCCESS:
            return setGetUserDetailsSuccess(state, action);
        case userInfoTypes.LOGOUT:
            return setLogout(state, action);
        case userInfoTypes.AUTO_LOGIN:
            return setAutoLogin(state, action);
        case userInfoTypes.SET_IS_OPU_SUCCESS:
            return setIsOPUSuccess(state, action);
        // payment actions
        case paymentTypes.GET_USER_PAYMENT_SUCCESS:
            return setPaymentInfo(state, action);
        // driversActions
        case driverActionTypes.GET_DRIVERS_LIST_SUCCESS:
            return setDriversInfoSuccess(state, action);
        case driverActionTypes.ADD_DRIVER_SUCCESS:
        case driverActionTypes.EDIT_PERMISSIONS_SUCCESS:
            return setDriverActionSuccess(state, action);
        // tags info
        case tagActionTypes.GET_TAGS_LIST_SUCCESS:
            return setTagListSuccess(state, action);
        // invoices info
        case invoiceActionTypes.GET_INVOICES_LIST_SUCCESS:
            return setInvoiceListSuccess(state, action);
        case invoiceActionTypes.GET_INVOICES_LIST_SUMMARY_SUCCESS:
            return setInvoicesSummaryListSuccess(state, action);

        // ************* state info ************* 
        // ************* Loading ************* 
        case userInfoTypes.START_REGISTER:
        case userInfoTypes.START_LOGIN:
        case userInfoTypes.START_UPDATE_USER:
        case paymentTypes.START_CREATE_USER_PAYMENT:
        case paymentTypes.START_UPDATE_USER_PAYMENT:
        case paymentTypes.START_DELETE_USER_PAYMENT:
        case userInfoTypes.START_FORGOTE_PASSWORD:
        case userInfoTypes.START_RESET_PASSWORD:
        case driverActionTypes.START_GET_DRIVERS_LIST:
        case driverActionTypes.START_ADD_DRIVER:
        case driverActionTypes.START_EDIT_DRIVER:
        case driverActionTypes.START_DELETE_DRIVER:
        case driverActionTypes.START_EDIT_PERMISSIONS:
        case tagActionTypes.START_ADD_TAG:
        case tagActionTypes.START_EDIT_TAG:
        case tagActionTypes.START_DELETE_TAG:
        case invoiceActionTypes.START_GET_INVOICES_LIST:
        case invoiceActionTypes.START_GET_INVOICES_SUMMARY_LIST:
            return setStateLoading(state, action);
        // ************* success ************* 
        case userInfoTypes.FORGOTE_PASSWORD_SUCCESS:
        case userInfoTypes.RESET_PASSWORD_SUCCESS:
        case userInfoTypes.UPDATE_USER_SUCCESS:
        case paymentTypes.CREATE_USER_PAYMENT_SUCCESS:
        case paymentTypes.UPDATE_USER_PAYMENT_SUCCESS:
        case paymentTypes.DELETE_USER_PAYMENT_SUCCESS:
        case driverActionTypes.EDIT_DRIVER_SUCCESS:
        case driverActionTypes.DELETE_DRIVER_SUCCESS:
        case tagActionTypes.ADD_TAG_SUCCESS:
        case tagActionTypes.EDIT_TAG_SUCCESS:
        case tagActionTypes.DELETE_TAG_SUCCESS:
            return setActionSuccess(state, action);
        case userInfoTypes.FORGOTE_PASSWORD_FAILURE:
        case userInfoTypes.RESET_PASSWORD_FAILURE:
        case userInfoTypes.LOGIN_FAILURE:
        case userInfoTypes.REGISTE_FAILURE:
        case userInfoTypes.UPDATE_USER_FAILUR:
        case paymentTypes.CREATE_USER_PAYMENT_FAILURE:
        case paymentTypes.UPDATE_USER_PAYMENT_FAILURE:
        case paymentTypes.DELETE_USER_PAYMENT_FAILURE:
        case driverActionTypes.ADD_DRIVER_FAILURE:
        case driverActionTypes.EDIT_DRIVER_FAILURE:
        case driverActionTypes.DELETE_DRIVER_FAILURE:
        case driverActionTypes.EDIT_PERMISSIONS_FAILURE:
        case driverActionTypes.GET_DRIVERS_LIST_FAILURE:
        case tagActionTypes.ADD_TAG_FAILURE:
        case tagActionTypes.EDIT_TAG_FAILURE:
        case tagActionTypes.DELETE_TAG_FAILURE:
            return setActionFailure(state, action);
        case userInfoTypes.RESET_STATE_INFO:
            return resetStateInfo(state, action);
        default:
            return state;
    }
}

// user info

const setLoginSuccess = (state, action) => {
    return {
        ...state,
        userInfo: {
            ...state.userInfo,
            token: action.payload,
            isInitialLogin: false
        },
        stateInfo: {
            isLoading: false,
            isSuccess: true,
            isError: false
        },
        isLoggedIn: true,
    };
}

const setLogout = (state, action) => {
    return initialState;
}

const setGetUserDetailsSuccess = (state, action) => {
    const userDetails = keysToLowerCase(action.payload)
    return {
        ...state,
        stateInfo: {
            ...state.stateInfo,
            isSuccess: false
        },
        userInfo: {
            ...state.userInfo,
            ...userDetails,
        }
    };
}

const setAutoLogin = (state, action) => {
    return {
        ...state,
        userInfo: {
            token: action.payload,
        },
        isLoggedIn: true
    };
}

const setIsOPUSuccess = (state, action) => {
    return {
        ...state,
        userInfo: {
            ...state.userInfo,
            isOPU: action.payload
        }
    };
}

// payment info

const setPaymentInfo = (state, action) => {
    return {
        ...state,
        paymentInfo: action.payload
    };
}

// drivers info

const setDriversInfoSuccess = (state, action) => {
    return {
        ...state,
        stateInfo: {
            ...state.stateInfo,
            isLoading: false,
            isSuccess: false,
            isError: false,
        },
        driversInfo: action.payload,
    };
}

const setDriverActionSuccess = (state, action) => {
    return {
        ...state,
        stateInfo: {
            ...state.stateInfo,
            isLoading: false,
            isSuccess: true,
            isError: false,
            error: action.payload.status,
        },
    };
}

// tags info

const setTagListSuccess = (state, action) => {
    return {
        ...state,
        stateInfo: {
            ...state.stateInfo,
            isLoading: false,
            isSuccess: false,
            isError: false,
        },
        tagsInfo: action.payload,
    };
}

// invoices info

const setInvoiceListSuccess = (state, action) => {
    return {
        ...state,
        stateInfo: {
            ...state.stateInfo,
            isLoading: false,
            isSuccess: false,
            isError: false,
        },
        invoicesInfo: {
            invoicesList: [...action.payload.chargingSummeriesList],
            driversList: [...action.payload.driversList],
            chargersNicknamesList: [...action.payload.chargersNicknamesList]
        }
    };
}

const setInvoicesSummaryListSuccess = (state, action) => {
    return {
        ...state,
        stateInfo: {
            ...state.stateInfo,
            isLoading: false,
            isSuccess: false,
            isError: false,
        },
        invoicesInfo: { ...state.invoicesInfo, invoicesSummaryList: action.payload },
    };
}

// state info

const setStateLoading = (state, action) => {
    return {
        ...state,
        stateInfo: {
            ...state.stateInfo,
            isLoading: true,
            isSuccess: false,
            isError: false,
            error: null
        }
    };
}

const setActionSuccess = (state, action) => {
    return {
        ...state,
        stateInfo: {
            ...state.stateInfo,
            isLoading: false,
            isSuccess: true,
            isError: false,
        },
    };
}

const setActionFailure = (state, action) => {
    return {
        ...state,
        stateInfo: {
            ...state.stateInfo,
            isLoading: false,
            isSuccess: false,
            isError: true,
            error: action.payload
        },
    };
}

const resetStateInfo = (state, action) => {
    return {
        ...state,
        stateInfo: initialState.stateInfo
    };
}


export default userInfoReducer;

